<template>
  <div>
    <div v-if="Object.keys(integrateList).length > 0">
      <ul class="tab-title">
        <li class="on">수강신청내역</li>
      </ul>
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>클래스명</th>
            <th>신청일</th>
            <th>결제여부</th>
            <th>상태</th>
            <th>수강취소</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in integrateList" :key="item.index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.className }}</td>
            <td>{{ item.createDate }}</td>
            <td>{{ item.payStatus || "-" }}</td>
            <td>{{ item.status }}</td>
            <td
              v-if="item.canclePossible"
              class="text_blue"
              @click="cancle(item, index)"
            >
              <a>취소하기</a>
            </td>
            <td v-else class="text_red">취소불가</td>
          </tr>
        </tbody>
      </table>
      <h3 class="blue_pg">
        * 수강취소는 신청완료 후 1시간 이내로 가능합니다. 이후 수강취소를
        원하시면 담당자에게 문의 부탁드립니다.
      </h3>
    </div>
    <div v-else>
      <ul class="tab-title">
        <li class="on">수강신청내역</li>
      </ul>
      <div class="tab-content tab-content-no-class">
        <h1 class="txt-center no-class-title">현재 신청된 과정이 없습니다.</h1>
        <h3 class="txt-center no-class-sub-title">
          <span class="apply-btn pointer">상단 ‘수강신청하기’ 버튼을</span> 눌러
          수강신청을 진행해주세요.
        </h3>
      </div>
    </div>
    <div v-if="Object.keys(mySugangInfo).length > 0" class="mg-t30">
      <ul class="tab-title">
        <li class="on">학습내역</li>
      </ul>
      <div class="tab-content" v-for="item in mySugangInfo" :key="item.index">
        <div class="left">
          <div class="state-wrap">
            <div
              :class="{
                'circle-blue': item.status === '수업예정',
                'circle-red': item.status === '수업중',
                'circle-black': item.status == '수업종료',
              }"
            ></div>
            <p>{{ item.status }}</p>
          </div>
          <div class="subject-wrap">
            <p>
              <span>{{ item.className }} </span>
            </p>
          </div>
        </div>
        <div class="right">
          <ul>
            <li>
              <p class="title">학습기간</p>
              <p>{{ item.sugangDate }}</p>
            </li>
            <li>
              <p class="title">학습시간</p>
              <p>{{ item.sugangTime }}</p>
            </li>
            <li>
              <p class="title">학습률</p>
              <div class="percent-wrap">
                <div class="percent-bg">
                  <div
                    class="percent"
                    :style="`width: ${item.completeRate}%`"
                  ></div>
                </div>
                <p>{{ item.completeRate }}% ({{ item.progress }})</p>
              </div>
            </li>
            <li>
              <p class="title">출석률</p>
              <div class="percent-wrap">
                <div class="percent-bg">
                  <div
                    class="percent"
                    :style="`width:${item.attendPercent}%`"
                  ></div>
                </div>
                <p>{{ item.attendPercent }}% ({{ item.attend }})</p>
              </div>
            </li>
          </ul>
          <div class="my-classroom" @click="goToMyClass(item)">
            <img src="@/assets/imgs/main/profile.png" alt="프로필" />
            <p>나의 강의실</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="mg-t30">
      <ul class="tab-title">
        <ul class="tab-title">
          <li class="on">학습내역</li>
        </ul>
      </ul>
      <div class="tab-content tab-content-no-class">
        <h1 class="txt-center no-class-title">
          현재 수강중인 과정이 없습니다.
        </h1>
        <h3 class="txt-center no-class-sub-title">
          교육 시작 후, 수업 현황을 확인하실 수 있습니다.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/runtime-core";
import { getSugangInfo } from "@/api/itmUserInfoapi/index";
import {
  getEmail,
  deleteSugangInfo,
  getProxyList,
} from "@/api/integratedapi/index";
import { getCtmUserInfo } from "@/api/ctmUserInfoapi/index";
import { getByIdPlatform } from "@/api/carrotEnglishapi/index";
import { applyHistoryList, ctmCancelClass } from "@/api/ctmApi/index";
import { itmApplyHistory, itmCancelClass } from "@/api/itmApi";
import { useStore } from "vuex";
import { onMounted } from "@vue/runtime-core";
import { itmMyClass, carrotEnglishApi } from "@/plugins/apiUrl";
import { baseConvert } from "@/utils/baseContert";
import { _integratedAxios } from "@/plugins/integragedAxios";
import { _itmAxios } from "@/plugins/itmAxios";
import router from "@/router";
export default {
  props: {
    courselist: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  emits: ["goApply"],
  setup(props, { emit }) {
    const sampleData = ref([]);
    const activeTab = ref(1);
    const store = useStore();
    const sugangList = ref([]);
    const mySugangInfo = ref({});
    const ctmApplyList = ref([]);
    const itmApplyList = ref([]);
    const integrateList = ref([]);
    const rtnEmail = ref("");
    const rtnitmCodeList = ref([]);
    const rtnctmCodeList = ref([]);
    const apiSugangInfo = () => {
      const param = {
        type: store.getters.getUserInfo.loginType,
        mobile: store.getters.getUserInfo.mobile,
        email: store.getters.getUserInfo.email,
        name: store.getters.getUserInfo.userName,
        code: store.getters.getCompanyInfo.companyIdx,
      };

      getSugangInfo(param)
        .then((res) => {
          const { success, data: respData } = res.data;
          if (success) {
            if (!Object.keys(respData).includes("err")) {
              for (const el of respData.list) {
                mySugangInfo.value.push(el);
              }
            } else {
              const { err_msg } = respData;
              console.error("error : ", err_msg);
            }
          }
        })
        .catch(function (error) {
          mySugangInfo.value = [];
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    };

    const apiCtmSugangInfo = () => {
      const param = {
        type: store.getters.getUserInfo.loginType,
        mobile: store.getters.getUserInfo.mobile,
        email: store.getters.getUserInfo.email,
        name: store.getters.getUserInfo.userName,
        code: store.getters.getCompanyInfo.companyIdx,
      };

      //테스트 parameter
      // const param = {
      //   type: store.getters.getUserInfo.loginType,
      //   mobile: "01066645741", //store.getters.getUserInfo.mobile,
      //   email: store.getters.getUserInfo.email,
      //   name: "제시카테스트2", //store.getters.getUserInfo.userName
      //   code: 159, //store.getters.getCompanyInfo.companyIdx,
      // };

      getCtmUserInfo(param)
        .then((res) => {
          const { success, data: respData } = res.data;
          if (success) {
            if (!Object.keys(respData).includes("err")) {
              for (const el of respData.list) {
                mySugangInfo.value.push(el);
              }
            } else {
              const { err_msg } = respData;
              console.error("error : ", err_msg);
            }
          } else {
            mySugangInfo.value = [];
          }
        })
        .catch((error) => {
          mySugangInfo.value = [];
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    };

    const cliceTab = (index) => {
      activeTab.value = index;
      const findItem = props.courselist.filter(item => item.isUse === 'Y').find((_, idx) => idx === index - 1);
      if (findItem) {
        mySugangInfo.value = [];
        apiSugangInfo();
        apiCtmSugangInfo();
      }
    };

    const goToMyClass = (item) => {
      if (item.courseType == "itm") {
        window.open(`${itmMyClass}/authLogin?email=${item.autoLoginEmail}`);
      } else if (item.courseType == "ctm") {
        const param = {
          email: item.autoLoginEmail,
        };

        getByIdPlatform(param)
          .then((res) => {
            const { idx } = res.data;
            goToMyCtmClass(idx);
          })
          .catch((error) => {
            alert(`나의강의실 입장에 실패하였습니다.`);
            console.error("get by Id getByIdPlatform error : ", error);
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    };

    const goToMyCtmClass = (idx) => {
      let dateObj = new Date();
      let month = dateObj.getUTCMonth() + 1; //months from 1-12
      let day = dateObj.getUTCDate();
      let year = dateObj.getUTCFullYear();

      let link = `${carrotEnglishApi}/lnk/D${baseConvert(
        Math.round(year + month + day),
        10,
        30,
      )}z${baseConvert(103 + 10000, 10, 30)}z${baseConvert(
        parseInt(idx) + 10000,
        10,
        30,
      )}`;

      window.open(link, "_blank");
    };

    const goApply = () => {
      emit("goApply");
    };
    const getUserEmail = async () => {
      if (
        store.getters.getUserInfo.mobile == "" ||
        store.getters.getUserInfo.mobile == undefined
      ) {
        rtnEmail.value = store.getters.getUserInfo.email;
      } else {
        await getEmail(store.getters.getCompanyInfo.code, {
          mobile: store.getters.getUserInfo.mobile,
        })
          .then((res) => {
            rtnEmail.value = res.data.data.email;
          })
          .catch((error) => {
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    };

    const makeApplyList = () => {
      integrateList.value = [];

      if (itmApplyList.value.length > 0) {
        itmApplyList.value.forEach((el) => {
          if (convertStatus(el.status, "itm") != "신청취소") {
            // itm 클래스명: 언어 / 과목명 형태로 표시
            const itmClassName = [el.language, el.subject_name]
              .filter(Boolean)
              .join(" / ");
            integrateList.value.push({
              type: "itm",
              className: itmClassName,
              createDate: el.create_date ? el.create_date.substring(0, 10) : "",
              payStatus: convertPayStatus(el.pay_status, "itm"),
              status: convertStatus(el.status, "itm"),
              idx: el.idx_itm_sugang_student_subject,
              canclePossible: el.create_date
                ? isWithinOneHour(el.create_date)
                : false,
            });
          }
        });
      }
      if (ctmApplyList.value.length > 0) {
        ctmApplyList.value.forEach((el) => {
          // 언어명과 과정명을 합쳐서 클래스명으로 표시
          const ctmClassName = [el.language_name, el.course_name]
            .filter(Boolean)
            .join(" / ");
          integrateList.value.push({
            type: "ctm",
            className: ctmClassName || "",
            createDate: el.createdate ? el.createdate.substring(0, 10) : "",
            payStatus: convertPayStatus(el.payment_yn, "ctm"),
            status: convertStatus(el.is_wait, "ctm"),
            canclePossible: el.createdate
              ? isWithinOneHour(el.createdate)
              : false,
            idx: el.idx,
            mobile: el.phone,
          });
        });
      }
    };

    const fetchProxyApplyList = async () => {
      try {
        const proxyParams = {
          sugangCode: store.getters.getCompanyInfo.code,
        };
        if (store.getters.getUserInfo.mobile) {
          proxyParams.proxyMobile = store.getters.getUserInfo.mobile;
        }
        if (store.getters.getUserInfo.email) {
          proxyParams.proxyEmail = store.getters.getUserInfo.email;
        }
        const { data: proxyRes } = await getProxyList(proxyParams);
        const proxyList = proxyRes.data || [];

        for (const proxyItem of proxyList) {
          try {
            if (proxyItem.courseType === "itm") {
              const itmRes = await _itmAxios.get(
                `/external/sugang/main/status/user?code=${proxyItem.courseCode}&email=${proxyItem.email}`,
              );
              const subjectList = itmRes.data.data.studentSubjectList || [];
              subjectList.forEach((el) => {
                if (el.status !== "신청취소") {
                  // itm 대리신청 클래스명: 언어 / 과목명 형태로 표시
                  const itmProxyClassName = [el.language, el.subjectName]
                    .filter(Boolean)
                    .join(" / ");
                  integrateList.value.push({
                    type: "itm",
                    className: itmProxyClassName,
                    createDate: el.createDay || "",
                    payStatus: el.payStatus || "-",
                    status: `대리신청 (학습자: ${proxyItem.name})`,
                    idx: el.idxItmSugangStudentSubject,
                    canclePossible: false,
                  });
                }
              });
            } else if (proxyItem.courseType === "ctm") {
              const ctmRes = await applyHistoryList({
                name: proxyItem.name,
                email: proxyItem.email,
                code: proxyItem.courseCode,
              });
              const subjectList = ctmRes.data.data.list || [];
              subjectList.forEach((el) => {
                // 언어명과 과정명을 합쳐서 클래스명으로 표시
                const ctmClassName = [el.language_name, el.course_name]
                  .filter(Boolean)
                  .join(" / ");
                integrateList.value.push({
                  type: "ctm",
                  className: ctmClassName || "",
                  createDate: el.createdate
                    ? el.createdate.substring(0, 10)
                    : "",
                  payStatus: convertPayStatus(el.payment_yn, "ctm"),
                  status: `대리신청 (학습자: ${proxyItem.name})`,
                  canclePossible: false,
                  idx: el.idx,
                  mobile: el.phone,
                });
              });
            }
          } catch (e) {
            console.error("대리인 수강 내역 조회 실패:", e);
          }
        }
      } catch (error) {
        console.error("대리인 리스트 조회 실패:", error);
      }
    };
    const isWithinOneHour = (createDate) => {
      const ONE_HOUR = 60 * 60 * 1000; // 1시간을 밀리초로 변환
      const currentTime = new Date(); // 현재 시간 가져오기
      const createDateObj = new Date(createDate); // create_date를 Date 객체로 변환
      // createDateObj에서 getTimezoneOffset을 통해 현재 시간대의 오프셋을 가져옴
      const timezoneOffset = createDateObj.getTimezoneOffset() * 60 * 1000;
      // createDateObj와 timezoneOffset을 고려하여 UTC 시간으로 변환
      const createDateUTC = createDateObj.getTime() + timezoneOffset;
      // createDateUTC와 currentTime을 비교하여 1시간 이내에 생성된 경우 true를 반환
      return currentTime - createDateUTC <= ONE_HOUR;
    };

    const convertPayStatus = (payStatus, type) => {
      if (type == "itm") {
        switch (payStatus) {
          case "Y":
            return "결제완료";
          case "N":
            return "미결제";
          case "X":
            return "결제없음";
          case "C":
            return "결제취소";
          case "P":
            return "결제취소대기";
          default:
            return "";
        }
      } else if (type == "ctm") {
        switch (payStatus) {
          case "Y":
            return "결제완료";
          case "N":
            return "결제없음";
          default:
            return "";
        }
      }
    };
    const convertStatus = (status, type) => {
      if (type == "itm") {
        switch (status) {
          case "Y":
            return "대기";
          case "N":
            return "신청완료";
          case "C":
            return "신청취소";
          case "F":
            return "신청실패";
          default:
            return "";
        }
      } else if (type == "ctm") {
        switch (status) {
          case "N":
            return "신청완료";
          case "Y":
            return "대기";
          default:
            return "";
        }
      }
    };

    const setApplyList = async () => {
      await getUserEmail();

      for (const el of rtnctmCodeList.value) {
        const res = await applyHistoryList({
          name: store.getters.getUserInfo.userName,
          email: rtnEmail.value,
          code: el,
        });

        if (res.data.data.list.length > 0) {
          res.data.data.list.forEach((el) => {
            ctmApplyList.value.push(el);
          });
        }
      }

      for (const el of rtnitmCodeList.value) {
        const res = await itmApplyHistory(el, {
          email: rtnEmail.value === "" ? "" : rtnEmail.value,
        });
        if (res.data.studentSubjectList.length > 0) {
          res.data.studentSubjectList.forEach((el) => {
            itmApplyList.value.push(el);
          });
        }
      }
      makeApplyList();
      await fetchProxyApplyList();
    };

    const setInitData = async () => {
      const res = await _integratedAxios.get(
        `/user/sugang/${store.getters.getCompanyInfo.code}`,
      );

      for (const el of res.data.data.courseList.filter(item => item.isUse === 'Y')) {
        if (el.courseType === "itm") {
          const itmRes = await _itmAxios.get(
            `/external/sugang/main/status?code=${el.code}`,
          );
          rtnitmCodeList.value.push(itmRes.data.data.pageIdx);
        } else if (el.courseType === "ctm") {
          rtnctmCodeList.value.push(el.code);
        }
      }
      await setApplyList();
    };

    const delIntegratedSugangInfo = async () => {
      const params = {
        code: store.getters.getCompanyInfo.code,
        courseIdx: store.getters.getCourseIdx,
        email: store.getters.getApplyInfo.email
          ? store.getters.getApplyInfo.email
          : store.getters.getUserInfo.email,
        mobile: store.getters.getApplyInfo.mobile
          ? store.getters.getApplyInfo.mobile
          : store.getters.getUserInfo.mobile,
      };

      return await deleteSugangInfo(params);
    };
    const cancle = (item, index) => {
      if (item.type == "ctm") {
        cancleCtm(item, index);
      } else if (item.type == "itm") {
        cancleItm(item, index);
      }
    };
    const cancleCtm = (item, index) => {
      if (confirm(`수업을 취소 하시겠습니까?`)) {
        ctmCancelClass(item.idx)
          .then(async (res) => {
            const { success, err_msg } = res.data;
            if (success) {
              try {
                const result = await deleteSugangInfo({
                  code: store.getters.getCompanyInfo["code"],
                  courseIdx: store.getters.getCourseIdx,
                  email: rtnEmail.value,
                  mobile: item.mobile,
                });

                const { success: integratedSuccess } = result.data;
                if (integratedSuccess) {
                  alert(`통합수강신청 수업취소에 성공하였습니다.`);
                  integrateList.value.splice(index, 1);
                  store.commit("setCtmApplyInfo", {});
                } else {
                  alert(`통합수강신청 수업취소에 실패하였습니다.`);
                }
              } catch (error) {
                if (error.response) {
                  // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                  alert(`서버에 에러가 발생하였습니다.`);
                } else if (error.request) {
                  // 요청이 이루어 졌으나 응답을 받지 못했습니다.
                  // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
                  // Node.js의 http.ClientRequest 인스턴스입니다.
                  console.log(error.request);
                  alert(`서버에 응답을 받지 못하였습니다.`);
                } else {
                  // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
                  console.log("Error", error.message);
                  alert(error.message);
                }
              }
            } else {
              alert(err_msg);
            }
          })
          .catch((error) => {
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    };
    const cancleItm = async (item, index) => {
      if (confirm(`${item.className}을 취소하시겠습니까?`)) {
        itmCancelClass(store.getters.getApplyInfo["email"], item["idx"])
          .then(async (res) => {
            const { success } = res.data;

            if (success) {
              //통합수강신청 삭제
              const result = await delIntegratedSugangInfo();

              const { success } = result.data;
              if (success) {
                alert("수강신청 취소에 성공하였습니다");
                integrateList.value.splice(index, 1);
                const clone = _.cloneDeep(
                  store.getters.getItmApplyCompleteList,
                );
                clone.splice(index, 1);
                store.commit("setItmApplyCompleteList", clone);
              } else {
                alert(
                  `수강신청 취소에 실패하였습니다.\n신청자분의 정보와 함께 매니저에게 문의 바랍니다`,
                );
              }
            } else {
              alert(
                `수강신청 취소에 실패하였습니다.\n신청자분의 정보와 함께 매니저에게 문의 바랍니다`,
              );
            }
          })
          .catch((error) => {
            alert(
              `수강신청 취소에 실패하였습니다.\n신청자분의 정보와 함께 매니저에게 문의 바랍니다`,
            );
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    };

    onMounted(async () => {
      //apiSugangInfo();
      await setInitData();
      cliceTab(1);
    });

    return {
      activeTab,
      cliceTab,
      sugangList,
      goToMyClass,
      mySugangInfo,
      goApply,
      ctmApplyList,
      integrateList,
      cancle,
      sampleData,
    };
  },
};
</script>

<style lang="scss" scoped>
.tab-wrap {
  .tab-title {
    display: flex;
    gap: 0 30px;
    margin-bottom: 29px;

    li {
      font-weight: $medium;
      color: #949494;
      padding-bottom: 7px;
      cursor: pointer;

      &.on {
        color: $blue;
        border-bottom: 3px solid $blue;
      }
    }
  }

  .tab-content {
    display: flex;
    border-radius: 14px;
    box-shadow: 6.3px 3.1px 10px 0 rgba(0, 0, 0, 0.03);
    border: solid 1px #dbdbdb;
    overflow: hidden;

    &:not(:first-child) {
      margin-top: 10px;
    }

    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0 58px;
      width: 260px;

      .state-wrap {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 0 7px;
        padding: 16px;
        background-color: $gray-dde0e4;
        border-bottom-right-radius: 14px;

        // 수업예정
        .circle-blue {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: $blue;
        }

        // 수업중
        .circle-red {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: $red;
        }

        // 수업종료
        .circle-black {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: $black;
        }

        > p {
          font-size: 15px;
          font-weight: $medium;
        }
      }

      .subject-wrap {
        font-size: 20px;
        text-align: center;

        span {
          font-size: 24px;
          font-weight: $bold;
          width: 240px;
          overflow: hidden;
          display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: keep-all;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      gap: 0 53px;
      padding: 5px 25px 5px 32px;
      border-left: 1px solid #dbdbdb;
      margin: 17px 0;
      flex-grow: 1;

      ul {
        display: flex;
        flex-direction: column;
        gap: 16px 0;
        flex-grow: 1;

        li {
          display: flex;
          align-items: center;
          gap: 0 21px;

          .title {
            width: 60px;
            flex: none;
            font-weight: $medium;
          }

          .percent-wrap {
            display: flex;
            align-items: center;
            gap: 0 17px;
            flex-grow: 1;

            .percent-bg {
              width: 100%;
              height: 15px;
              background-color: $gray-dde0e4;
              border-radius: 7px;

              .percent {
                width: 0%;
                // width: 80%;
                height: inherit;
                background-color: $black;
                border-radius: inherit;
              }
            }

            > P {
              width: 90px;
              flex: none;
            }
          }
        }
      }

      .my-classroom {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 9px 0;
        height: 100%;
        border-radius: 14px;
        border: solid 1px #1e78ff;
        padding: 37px 26px;
        cursor: pointer;

        img {
          width: 47px;
        }

        p {
          color: $blue;
          font-weight: $bold;
        }
      }
    }
  }

  .tab-content-no-class {
    background-color: $gray-f6f7f8;
    display: flex;
    flex-direction: column;
    padding: 65px 0;
  }

  .no-class-title {
    font-size: 30.5px;
    color: $black-000;
    font-weight: $bold;
  }

  .no-class-sub-title {
    font-size: 22px;
  }

  .apply-btn {
    color: $blue;
  }
  .blue_pg {
    color: $blue;
    margin-top: 15px;
    // padding-left: 40px;
  }

  body {
    padding: 1.5em;
    background: #f5f5f5;
  }

  table {
    border: 1px #a39485 solid;
    font-size: 0.9em;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    width: 100%;
    border-collapse: collapse;
    border-radius: 5px;
    overflow: hidden;
  }

  th {
    text-align: center;
  }

  thead {
    font-weight: bold;
    background-color: rgba(38, 38, 38, 0.1);
  }

  td,
  th {
    padding: 1em 0.5em;
    vertical-align: middle;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  td {
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
  }

  .text_blue {
    color: #1e78ff;
    cursor: pointer;
  }
  .text_red {
    color: #ff1e1e;
  }
  .mg-t30 {
    margin-top: 30px;
  }
}
</style>
